import * as React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import useStyles from './CheckBoxCell.styles';

const CheckBoxCell = (props: GridCellProps) => {
    const classes = useStyles();
    const { dataItem } = props;
    const field = props.field || '';
    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    const handleChange = (e: CheckboxChangeEvent) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value,
            });
        }
    };

    return (
        <td className={props.className} style={{ textAlign: 'center' }}>
            {dataItem.inEdit ? (
                <Checkbox value={dataValue} onChange={handleChange} />
            ) : dataValue ? (
                <CheckBoxIcon className={classes.checkbox} />
            ) : (
                <CheckBoxOutlineBlankIcon className={classes.checkbox} />
            )}
        </td>
    );
};

export default CheckBoxCell;
